import { Injectable } from '@angular/core';

import { GRpcRequestType } from '@lyra/app/core/api/grpc/grpc-class.type';
import { grpcOperator } from '@lyra/app/core/api/grpc/pipe-operators/grpc';
import { Empty, UserApi } from '@mark/web-contracts';
import { from } from 'rxjs';

import { GrpcCommonService } from './common.service';

export type ISurveyInit = GRpcRequestType<UserApi.SurveyBhUserWebGrpcContractClient['Init']>;
export type ISurveyGetQuestions = GRpcRequestType<UserApi.SurveyBhUserWebGrpcContractClient['GetQuestions']>;
export type ISurveyProvideAnswers = GRpcRequestType<UserApi.SurveyBhUserWebGrpcContractClient['ProvideAnswers']>;

@Injectable()
export class SurveyBhUserGrpcContractService extends GrpcCommonService<UserApi.SurveyBhUserWebGrpcContractClient> {
  constructor(protected _GrpcContract: UserApi.SurveyBhUserWebGrpcContractClient) {
    super();
  }

  initialize(request: ISurveyInit) {
    return from(
      this._GrpcContract.Init(UserApi.InitSurveyBhUserWpcRequest.fromObject(request), this.getMetadata()),
    ).pipe(grpcOperator());
  }

  getGoals() {
    return from(this._GrpcContract.GetGoals(new Empty(), this.getMetadata())).pipe(grpcOperator());
  }

  getQuestions(request: ISurveyGetQuestions) {
    return from(this._GrpcContract.GetQuestions(UserApi.WebRequest_Guid.fromObject(request), this.getMetadata())).pipe(
      grpcOperator(),
    );
  }

  provideAnswers(request: ISurveyProvideAnswers) {
    return from(
      this._GrpcContract.ProvideAnswers(UserApi.ProvideAnswersBhUserWpcRequest.fromObject(request), this.getMetadata()),
    ).pipe(grpcOperator());
  }

  getLastCompleted() {
    return from(this._GrpcContract.GetLastCompleted(new Empty(), this.getMetadata())).pipe(grpcOperator());
  }
}
